module.exports = __webpack_public_path__ + "img/mira_550m_detail_rsh.fda74dad.jpg";